import { Modal, Text, Stack, Group, Divider } from "@mantine/core"
import { IconTrash } from "@tabler/icons-react"
import { Button, EqualWidthGrid } from "@tfg/ui"
import { useTranslation } from "react-i18next"

import { ContactResponses } from "@tfg/types/endpoints/contacts"

import { useDeleteContactMutation } from "~/pages/SupplierPortal/Contacts/hooks/useDeleteContactMutation.ts"

interface Props {
  isOpen: boolean
  onClose: () => void
  contact: ContactResponses.Contact
}

export const DeleteContactModal = ({ isOpen, onClose, contact }: Props) => {
  const { t } = useTranslation("supplier")

  const { mutate: deleteContact, isLoading } = useDeleteContactMutation(
    contact.id
  )

  return (
    <Modal
      opened={isOpen}
      onClose={onClose}
      title={
        <Stack>
          <Text fw={700} size="lg">
            {t("contactModal.delete.title")}
          </Text>
        </Stack>
      }
    >
      <Stack>
        <Divider w="100%" />
        <Stack gap="xs">
          <Text>{t("contactModal.delete.message")}</Text>
          <Group gap={2}>
            <Text fw={700}>{contact.user.name}</Text>
            <Text size="xs">{contact.user.email}</Text>
          </Group>
        </Stack>
        <EqualWidthGrid>
          <Button
            variant="secondary-critical"
            onClick={() => onClose()}
            fullWidth={true}
          >
            {t("contactModal.delete.cancel")}
          </Button>
          <Button
            onClick={() => {
              deleteContact()
              onClose()
            }}
            fullWidth={true}
            loading={isLoading}
            color="red"
            icon={<IconTrash />}
          >
            {t("contactModal.delete.confirm")}
          </Button>
        </EqualWidthGrid>
      </Stack>
    </Modal>
  )
}
